<template>
    <div v-if="isDev" class="environment-banner">
        测试环境
    </div>
</template>

<script>
export default {
    name: 'EnvironmentBanner',
    computed: {
        isDev() {
            return process.env.NODE_ENV === 'development';
        }
    }
};
</script>

<style scoped>
.environment-banner {
    width: 10%;
    text-align: center;
    color: var(--error-color, #d32f2f); /* 使用 CSS 变量 */
    font-size: 16px;
    font-weight: bold;
    padding: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 1000; /* 确保在最上层 */
    border-bottom-right-radius: 10px;
    position: fixed; /* 固定在页面顶部 */
    top: 0; /* 距离顶部 0 */
    right: 0px;
    animation: blink 1s ease-in-out infinite alternate;
}

@keyframes blink {
    from {
        opacity: 1;
    }
    to {
        opacity: 0.7;
    }
}
</style>